<template>
  <div class="wrapper fill-vh">
    <MainInfo />
    <EmailForm :namefromquery="namefromquery" :emailfromquery="emailfromquery" />
  </div>
</template>

<script>
// @ is an alias to /src
import MainInfo from "@/components/MainInfo";
import EmailForm from "@/components/EmailForm";
import { mapGetters } from "vuex";

export default {
  name: "Home",
  data: () => ({
    namefromquery: '',
    emailfromquery: ''
  }),
  components: {
    MainInfo,
    EmailForm
  },
  computed: mapGetters(["getSelectedClub", "allClubs"]),
  created() {
    this.namefromquery = this.$route.query.name;
    this.emailfromquery = this.$route.query.email;
  }
};
</script>
<style scoped>
@media (min-width: 1025px) {
  .wrapper {
    display: flex;
  }
}
</style>
